module.exports = __webpack_public_path__ + "assets/982079dd961a88196be9cb5da793ca2a.png";